import { useState, useEffect, useMemo, } from 'react';
import { UrlApi } from '../../../../services/apirest';
import { getData, } from '../../../../services/library';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import UploadFiles from '../../UploadFiles';
import { formatoImporte } from '../../formatoImporte';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { createTheme, IconButton, ThemeProvider, Tooltip, useTheme } from '@mui/material';
import {
  Autocomplete,
  Box,
  Select,
  FormControl,
  InputLabel,
  Stack,
  FormControlLabel,
  TextField,
  Grid,
  Checkbox,
  MenuItem,
  Container,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import Title from '../../../Title';
import Notify from '../../../Notify';
import AgregarMateriales from '../../requerimientos/ver_requerimientos/lista_requerimientos/AgregarMateriales';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Modalcondicionnull from './Modalcondicionnull';
import { logEventos } from '../../../../services/services';
import FormAgregarPedido from './AddRequerimientos/FormAgregarPedido';
import { validarOrdenCompra, orchestrateTransaction } from '../AddOrdenes/ArticulosPendientes/funciones';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import Modalhaycomentarios from './Modalhaycomentarios';

const AddOrdenCompra = (props) => {
  const globalTheme = useTheme();
  const [reqMaterial] = useState(props.datos);
  const [uuidordencompra] = useState(uuidv4());
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [openclose, setOpenClose] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [tabla, settabla] = useState(true);
  const [proveedorSelected, setproveedorSelected] = useState(null);
  const [condVentaNew, setcondVentaNew] = useState(null);
  const [modalVacio, setmodalVacio] = useState(false);
  const [proveedor, setproveedor] = useState([]);
  const [listaMateriales, setlistaMateriales] = useState([]);
  const [tipoMoneda, settipoMoneda] = useState([]);
  const [bonificacionPesos, setBonificacionPesos] = useState(null);
  const [bonificacionPorcentaje, setBonificacionPorcentaje] = useState(null);
  const [totalFinal, settotalFinal] = useState(0);
  const [subtotal, setsubtotal] = useState(0);
  const [CondVenta, setCondVenta] = useState([]);
  const [empresas, setempresas] = useState([]);
  const [observacionesReq, setobservacionesReq] = useState(reqMaterial.comentarios_internos);
  const [empSelected, setempSelected] = useState(null);
  const [modalListaPendiente, setmodalListaPendiente] = useState(false);
  const [modalOtrosPendientes, setModalOtrosPendientes] = useState(false);
  const [callbackPendiente, setCallbackPendiente] = useState(null);
  const [pendientes, setPendientes] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelected, setusuarioSelected] = useState();
  const [obs, setObs] = useState(null);
  const [verobs, setverobs] = useState(false)
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: '',
    severity: '',
    color: '',
  });
  const [estadoRequerimiento, setEstadoRequerimiento] = useState(reqMaterial.estado);
  const [datosFormulario, setdatosFormulario] = useState({
    comentarios_internos: null,
    pago_anticipado: false,
    iva_incluido: false,
    tipo_moneda: 83,
    fecha_entrega: reqMaterial ? moment(reqMaterial.fecha_entrega).format('YYYY-MM-DD') : '',
    uuid_ordencompra: uuidordencompra,
    origen: 'requerimiento',
    usuario_autoriza: null,
    observaciones: ""
  });

  const obtenerListaMaterial = () => {
    if (!reqMaterial?.uuid_requerimiento) {
      setNotificacion({
        open: true,
        mensaje: 'UUID de requerimiento inválido',
        severity: 'error',
        color: '#FADBD8',
      });
      return;
    }
    getData(`/lista_materiales/addorden/${reqMaterial.uuid_requerimiento}/${uuidordencompra}`, (data) => {
      setlistaMateriales(data); // Sin consolidar inicialmente
      if (listaMateriales.length > 0) {
        // console.log("entro en este if para saber que estado le pongo"); 
        // console.log("anda a saber que es esto listaMateriales[0]?.estado", listaMateriales[0]); 

        setEstadoRequerimiento(50);
      } else {
        setEstadoRequerimiento(null);
      }
    }).catch((error) => {
      console.error('Error al obtener lista de materiales:', error);
      setNotificacion({
        open: true,
        mensaje: 'Error al cargar los materiales',
        severity: 'error',
        color: '#FADBD8',
      });
    });
  };

  const obtenerProveedores = () => {
    fetch(UrlApi + '/proveedores/activos')
      .then((data) => data.json())
      .then((data) => setproveedor(data));
  };

  const obtenerDatosReq = () => {
    getData(`/requerimientos_materiales/ordencompra/${uuidordencompra}`, setObs)
  };

  /*Obtengo todos los autorizantes de la tabla "autorizantes_compras y en este caso voy a filtrar solamente los que tengan nivel 4 que es el del usuario jefe de compras.
   más adelante se validará que usuario(s) tendran que aparecer para autorizar la compra dependiendo el monto de la orden de compra. " */
  const obtenerUsuarios = () => {
    getData('/autorizantes_compras',
      (data) => {
        const filtrados = data.filter((d) => d.nivel === 4);
        // console.log("filtrados", filtrados);
        setUsuarios(filtrados);
        setusuarioSelected(filtrados[0]?.usuario)
      });
  };

  useEffect(() => {
    if (usuarios) {
      setdatosFormulario((prev) => ({
        ...prev,
        usuario_autoriza: usuarioSelected
      }))
    }
  }, [usuarios])

  useEffect(() => {
    if (proveedorSelected) {
      setcondVentaNew(proveedorSelected.id_condicionventa);
      setmodalVacio(proveedorSelected.id_condicionventa === null);
    }
  }, [proveedorSelected]);

  useEffect(() => {
    setempSelected(reqMaterial.idempresa);
  }, [reqMaterial]);

  useEffect(() => {
    getBonificacionPorcentaje();
  }, [bonificacionPorcentaje, subtotal, bonificacionPesos]);

  useEffect(() => {
    listaMateriales && calcularTotales();
  }, [listaMateriales, bonificacionPesos, bonificacionPorcentaje]);

  useEffect(() => {
    getData('/desplegables/tipoMoneda', settipoMoneda);
    getData('/condicion_pago', setCondVenta);
    getData('/empresas', setempresas);
    obtenerProveedores();
    obtenerListaMaterial();
    obtenerUsuarios()
  }, [reqMaterial, uuidordencompra]);

  useEffect(() => {
    obtenerDatosReq()
    // console.log("vuelvo");
  }, [openDialog]);

  const calcularTotales = () => {
    let subtotalCalc = 0;
    if (listaMateriales) {
      listaMateriales.forEach((item) => {
        subtotalCalc += item.subtotal || 0;
      });
      setsubtotal(subtotalCalc);
    }
  };

  const getBonificacionPorcentaje = () => {
    if (subtotal && bonificacionPorcentaje) {
      settotalFinal(subtotal - (subtotal * bonificacionPorcentaje / 100));
    } else if (subtotal && bonificacionPesos) {
      settotalFinal(subtotal - bonificacionPesos);
    } else {
      settotalFinal(subtotal);
    }
  };

  const handleCloseNotificacion = () => {
    setNotificacion({ ...notificacion, open: false });
  };

  const almacenar = (e) => {
    setdatosFormulario({ ...datosFormulario, [e.target.name]: e.target.value ? e.target.value : null });
  };

  const handleOnClickCheckBox = (e) => {
    setdatosFormulario({ ...datosFormulario, [e.target.name]: e.target.checked });
  };

  const handleClose = () => {
    props.autorizados(true)
    props.actualizar();
    props.tabla(true);
    props.alta(false);
    props.tab(true);

  };

  const handleAbrirModal = () => {
    setopenDialog(true);
  };

  const guardarTodo = async ({ exitEditingMode, row, values }) => {

    const parseNumber = (val) =>
      val !== null && val !== undefined && val !== ''
        ? parseFloat(String(val).replace(',', '.'))
        : null;

    const precio_unitario = parseNumber(values.precio_unitario);
    const cantidad = values.cantidad_actualizada;
    const bonificacion_pesos = parseNumber(values.bonificacion_pesos);
    const bonificacion_porcentaje = parseNumber(values.bonificacion_porcentaje);

    let subtotal = 0;

    if (bonificacion_pesos) {
      subtotal = cantidad * precio_unitario - bonificacion_pesos;
    } else if (bonificacion_porcentaje) {
      subtotal = cantidad * precio_unitario * (1 - bonificacion_porcentaje / 100);
    } else {
      subtotal = cantidad * precio_unitario;
    }

    await fetch(`${UrlApi}/lista_materiales/lista/${row.original.idlista}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        material: values.material || null,
        precio_unitario,
        cantidad_actualizada: cantidad,
        bonificacion_pesos,
        bonificacion_porcentaje,
        uuid_ordencompra: uuidordencompra,
        usuario: localStorage.getItem('user'),
        subtotal,
      }),
    });

    logEventos(
      'Actualizar lista materiales para agregar a orden compra',
      'AddOrdencompra',
      'Generar orden compra',
      localStorage.getItem('user')
    );

    obtenerListaMaterial();
    exitEditingMode();
  };

  const generarOrdenCompra = async (e) => {
    if (estadoRequerimiento === 58) {
      setNotificacion({
        open: true,
        mensaje: "El requerimiento ya está completado. No se pueden generar más órdenes de compra.",
        severity: "error",
        color: "#FADBD8",
      });
      return;
    }

    if (!validarFormulario()) return;

    setIsProcessing(true);


    setCallbackPendiente(() => () => handleGenerarTransaccion(e));

    await validarOrdenCompra(
      e,
      listaMateriales,
      setPendientes,
      reqMaterial,
      setmodalListaPendiente,
      () => handleGenerarTransaccion(e),
      setNotificacion,
      setIsProcessing,
      setModalOtrosPendientes
    );
  };

  // console.log("obs", obs);


  const handleGenerarTransaccion = (e) => {
    orchestrateTransaction(
      e,
      listaMateriales,
      pendientes,
      proveedorSelected,
      datosFormulario,
      condVentaNew,
      totalFinal,
      bonificacionPesos,
      bonificacionPorcentaje,
      reqMaterial,
      observacionesReq,
      empSelected,
      handleClose,
      setNotificacion,
      () => {
        props.alta(false);
        props.tabla(true);
        props.tab(true);
        props.actualizar();
      },
      usuarioSelected
    );
  };

  const handleCloseModal = (e) => {
    setmodalListaPendiente(false);
    setIsProcessing(true);
    props.alta(false);
    props.tabla(true);
    props.tab(true);
    props.actualizar();

    handleGenerarTransaccion(e);
  };

  const validarFormulario = () => {
    const errors = [];

    if (!proveedorSelected) errors.push("Debe seleccionar un proveedor");
    if (!condVentaNew) errors.push("Debe seleccionar una condición de venta");
    if (!empSelected) errors.push("Debe seleccionar una empresa para facturar");
    // if (condVentaNew === 20 && !datosFormulario.comentarios_internos)
    //   errors.push(
    //     "Los comentarios internos son obligatorios para la condición 'Otras'"
    //   );
    if (!listaMateriales.length)
      errors.push("Debe haber al menos un material en la lista");
    if (!usuarioSelected) errors.push("Debe seleccionar un usuario");

    // ✅ Filtrar solo los materiales con uuid_ordencompra asignado
    const materialesSeleccionados = listaMateriales.filter(
      (item) => item.uuid_ordencompra && item.uuid_ordencompra !== ""
    );

    if (materialesSeleccionados.length === 0) {
      errors.push("Debe seleccionar al menos un material válido");
    }

    materialesSeleccionados.forEach((item, index) => {
      const erroresItem = [];

      if (
        item.cantidad === null ||
        item.cantidad === undefined ||
        item.cantidad <= 0
      ) {
        erroresItem.push("cantidad inválida");
      }

      const sinArticuloYMaterial =
        !item.id_articulo && (!item.material || item.material === "");
      if (sinArticuloYMaterial) {
        erroresItem.push("falta artículo o descripción");
      }

      if (item.precio_unitario === null || item.precio_unitario === "") {
        erroresItem.push("precio unitario faltante");
      }

      if (item.subtotal === null || item.subtotal === "") {
        erroresItem.push("subtotal faltante");
      }

      if (erroresItem.length > 0) {
        errors.push(
          `Ítem #${index + 1} (uuid: ${item.uuid_ordencompra}): ${erroresItem.join(", ")}`
        );
      }
    });

    if (errors.length) {
      setNotificacion({
        open: true,
        mensaje: errors[0], // solo muestro el primero
        severity: "error",
        color: "#FADBD8",
      });
      return false;
    }

    return true;
  };

  const columns = useMemo(
    () => [
      {
        header: 'Requerido',
        accessorKey: 'cantidad',
        enableEditing: false,
        size: 50,
      },
      {
        header: 'A Comprar',
        accessorKey: 'cantidad_actualizada',
        type: 'number',
        size: 50,
      },
      {
        header: 'Articulo',
        accessorKey: 'material',
        accessorFn: (lm) => lm.nombre ?? lm.material,
        enableEditing: (row) => !row.original.id_articulo,
        size: 100,
      },
      {
        header: 'Unidad',
        accessorFn: (lm) => lm.descripcion ?? lm.descripcion_material,
        enableEditing: false,
        size: 40,
      },
      // {
      //   header: '$ Unitario',
      //   accessorKey: 'precio_unitario',
      //   type: 'numeric',
      //   required: true,
      //   size: 40,
      // },
      {
        header: '$ Unitario',
        accessorKey: 'precio_unitario',
        size: 40,
        muiEditTextFieldProps: ({ cell }) => ({
          type: 'text',
          inputMode: 'decimal',
          // al abrir la edición, reemplazamos el punto por coma
          defaultValue: String(cell.getValue() ?? '').replace('.', ','),
          onChange: (e) => {
            // solo números, coma o punto
            e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
          },
        }),
        //aca mostramos como se muestra 
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value == null || value === '') return '';

          //y aca formateamos jajajajaja
          return new Intl.NumberFormat('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(value));
        },
      },
      {
        header: 'Bonif %',
        accessorKey: 'bonificacion_porcentaje',
        type: 'numeric',
        size: 40,
      },
      {
        header: 'Bonif $',
        accessorKey: 'bonificacion_pesos',
        type: 'numeric',
        size: 40,
        Cell: ({ cell }) => formatoImporte(cell.getValue()),
      },
      {
        header: 'Subtotal',
        accessorKey: 'subtotal',
        enableEditing: false,
        type: 'numeric',
        size: 40,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value == null || value === '') return '';
          // 👇 formatea como 1.234,56
          return new Intl.NumberFormat('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        },
      },
    ],
    []
  );

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: { main: 'rgb(255,122,0)' },
          background: {
            default: globalTheme.palette.mode === 'light' ? 'rgb(234, 239, 241)' : '#000',
          },
        },
        typography: {
          button: { textTransform: 'none', fontSize: '1rem' },
        },
        components: {
          MuiTooltip: { styleOverrides: { tooltip: { fontSize: '0.8rem' } } },
        },
      }),
    [globalTheme]
  );

  const tableHeadCellProps = {
    align: 'center',
    sx: {
      fontSize: 14,
      color: 'black',
      fontWeight: 'normal',
      backgroundColor: '#D4E6F1',
      borderColor: '#FDFEFE',
    },
  };

  const initialState = {
    density: 'compact',
    pagination: { pageIndex: 0, pageSize: 15 },
  };

  const style = { backgroundColor: '#ffffff', width: '100%' };

  const pendientesRequerimientoOriginal = useMemo(() => {
    return pendientes.filter(
      (item) =>
        String(item.uuid_requerimiento).trim().toLowerCase() ===
        String(reqMaterial.uuid_requerimiento).trim().toLowerCase()
    );
  }, [pendientes, reqMaterial]);

  // console.log("estadoRequerimiento",estadoRequerimiento);
  // console.log("ons", obs);
  // console.log(reqMaterial);





  //y aca valido que el usuario seleccionado tenga el limite de compra mayor al monto total de la orden de compra. 
  //está comentado porque esta funcionalidad no se va a usar ahora. 
  // useEffect(() => {
  //   if (usuarioSelected && (Number(totalFinal) > Number(usuarioSelected.limite_compra))) {
  //     alert("El usuario seleccionado para autorizar la orden de compra no tiene permisos para el monto total. Por favor, seleccione otro usuario autorizado")
  //   }
  // }, [totalFinal, usuarioSelected])

  return (
    <div>
      <Container maxWidth="xl">
        <Title titulo={`Generar orden de compra (requerimiento ${reqMaterial.id}) `} handleClose={handleClose} />
        <Box backgroundColor="#F4F6F6" mt={1} p={2} mb={2} border={0.5} borderColor="#ABB2B9" borderRadius={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <Autocomplete
                disableClearable
                focused
                size="small"
                style={style}
                noOptionsText="Proveedor INEXISTENTE"
                options={proveedor}
                autoHighlight
                getOptionLabel={(prov) => `${prov.nombre_fantasia || prov.razon_social} - ${prov.nro_cuit}`}
                onChange={(e, value) => setproveedorSelected(value)}
                renderInput={(params) => (
                  <TextField
                    focused
                    fullWidth
                    placeholder="Tipee para buscar proveedores..."
                    {...params}
                    variant="outlined"
                    size="small"
                    label="Proveedores"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth size="small" focused required>
                <InputLabel>Condicion De Venta</InputLabel>
                <Select
                  variant="outlined"
                  value={condVentaNew || ''}
                  onChange={(e) => setcondVentaNew(e.target.value)}
                  label="Condición de venta"
                  style={style}
                >
                  {CondVenta.map((el) => (
                    <MenuItem key={el.id} value={el.id}>
                      {el.condicion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth style={style} focused required size="small">
                <InputLabel>Moneda</InputLabel>
                <Select
                  variant="outlined"
                  name="tipo_moneda"
                  value={datosFormulario.tipo_moneda}
                  onChange={almacenar}
                  label="Moneda"
                >
                  {tipoMoneda.map((el) => (
                    <MenuItem key={el.id} value={el.id}>
                      {el.valor}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth style={style} focused required size="small">
                <InputLabel>Facturar a</InputLabel>
                <Select
                  variant="outlined"
                  value={empSelected || ''}
                  onChange={(e) => setempSelected(e.target.value)}
                  label="Facturar a"
                >
                  {empresas.map((el) => (
                    <MenuItem key={el.idempresa} value={el.idempresa}>
                      {el.empresa}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <FormControlLabel
                control={<Checkbox name="iva_incluido" onClick={handleOnClickCheckBox} />}
                label="Impuestos incluidos"
                labelPlacement="start"
              />
            </Grid>
            <Grid item xs={1} ml={3}>
              <FormControlLabel
                control={<Checkbox name="pago_anticipado" onClick={handleOnClickCheckBox} />}
                label="Pago anticipado"
                labelPlacement="start"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" p={1} mb={1.5}>
            <Grid item xs={1.5}>
              <TextField
                focused
                variant="outlined"
                fullWidth
                style={style}
                label="Sucursal"
                size="small"
                value={reqMaterial.nombre_sucursal || ''}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={1.5}>
              <TextField
                focused
                variant="outlined"
                fullWidth
                style={style}
                label="Movil"
                size="small"
                value={reqMaterial.patente || 'No hay registro'}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={1.7}>
              <TextField
                focused
                variant="outlined"
                style={style}
                label="Solicitó"
                size="small"
                value={reqMaterial.usuario_registrante}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={1.7}>
              <TextField
                focused
                variant="outlined"
                style={style}
                label="Autorizanta Requerimiento"
                size="small"
                value={reqMaterial.usuario_autorizante || 'No hay registro'}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={1.7}>
              <TextField
                focused
                style={style}
                label="Fecha autorizado"
                size="small"
                value={
                  reqMaterial.fecha_autorizado
                    ? moment(reqMaterial.fecha_autorizado).format('DD-MM-YYYY')
                    : 'No hay registro'
                }
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={1.7}>
              <TextField
                focused
                variant="outlined"
                style={style}
                onChange={almacenar}
                size="small"
                label="Fecha de entrega"
                type="date"
                name="fecha_entrega"
                value={datosFormulario.fecha_entrega ?? null}
              />
            </Grid>
            <Grid item xs={1.7}>
              <FormControl fullWidth size="small" focused required>
                <InputLabel>Autoriza orden</InputLabel>
                <Select
                  variant="outlined"
                  value={usuarioSelected || null}
                  onChange={(e) => setusuarioSelected(e.target.value)}
                  label="Autoriza orden"
                  style={style}
                >
                  {usuarios.map((el) => (
                    <MenuItem key={el.id} value={el.usuario}>
                      {el.nombre_apellido}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {tabla && listaMateriales.length > 0 && (
            <Box mt={2} boxShadow={3}>
              <ThemeProvider theme={tableTheme}>
                <MaterialReactTable
                  enableColumnResizing
                  enableEditing
                  columns={columns}
                  data={listaMateriales}
                  positionActionsColumn="last"
                  muiTableHeadCellProps={tableHeadCellProps}
                  muiTableBodyCellProps={({ row, column }) => ({
                    align: 'left',
                    sx: {
                      backgroundColor: '#fff',
                      color: 'black',
                      borderColor: 'black',
                    },
                  })}
                  localization={MRT_Localization_ES}
                  enableColumnActions={false}
                  enableDensityToggle={false}
                  layoutMode="grid"
                  enableExpandAll={false}
                  enableToolbarInternalActions={true}
                  editingMode="row"
                  enablePagination={true}
                  enableFullScreenToggle={false}
                  enableColumnFilters={false}
                  enableHiding={false}
                  enableBottomToolbar={true}
                  enableColumnDragging={false}
                  positionExpandColumn="first"
                  enableTopToolbar={false}
                  enableStickyFooter
                  enableGlobalFilter={false}
                  initialState={initialState}
                  onEditingRowSave={guardarTodo}
                  displayColumnDefOptions={{
                    'mrt-row-actions': {
                      size: 40,
                    },
                  }}
                />
              </ThemeProvider>
            </Box>
          )}

          <Grid container justifyContent="space-between" alignItems="center" mt={1}>
            <Stack spacing={2} direction="row" padding={1}>
              <Button
                onClick={handleAbrirModal}
                style={{ backgroundColor: '#363979', color: 'white' }}
                variant="contained"
              >
                Agregar Pedidos
              </Button>
              <Button
                onClick={() => setOpenClose(!openclose)}
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<AttachFileIcon />}
              >
                Ver presupuestos
              </Button>
              <Button
                size="small"
                onClick={() => setCreateModalOpen(true)}
                color="primary"
                variant="contained"
              >
                Agregar Articulos
              </Button>
            </Stack>

            <Grid item xs={1} mt={1}>
              <TextField
                disabled={!!bonificacionPorcentaje}
                focused
                variant="outlined"
                label="Bonificación $"
                size="small"
                value={bonificacionPesos || ''}
                onChange={(e) => setBonificacionPesos(e.target.value || null)}
                style={{ marginLeft: 250, backgroundColor: '#ffffff', width: '100%' }}
              />
            </Grid>
            <Grid item xs={1} mt={1} >
              <TextField
                disabled={!!bonificacionPesos}
                focused
                variant="outlined"
                label="Bonificación %"
                size="small"
                value={bonificacionPorcentaje || ''}
                onChange={(e) => setBonificacionPorcentaje(e.target.value || null)}
                style={{ marginLeft: 125, backgroundColor: '#ffffff', width: '100%' }}
              />
            </Grid>
            <Grid item xs={1} mt={1} >
              <TextField
                focused
                variant="outlined"
                label="Total"
                size="small"
                value={totalFinal.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                InputProps={{ readOnly: true }}
                style={{ marginLeft: 'auto', backgroundColor: '#ffffff', width: '100%' }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" p={1}>
            <Grid item xs={4}>
              <TextField
                focused
                variant="outlined"
                style={style}
                multiline
                size="small"
                name="comentarios_internos"
                label="Observaciones del requerimiento"
                value={observacionesReq}
                onChange={(e) => setobservacionesReq(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                placeholder="Comentarios internos"
                variant="outlined"
                focused
                required={condVentaNew === 20}
                style={style}
                size="small"
                name="comentarios_internos"
                multiline
                label="Comentarios internos COMPRAS"
                onChange={almacenar}
                value={datosFormulario.comentarios_internos || ''}
              />
            </Grid>
            <Grid item xs={obs && obs.length !== 0 ? 3.5 : 4}>
              <TextField
                focused
                variant="outlined"
                style={style}
                size="small"
                label="Observaciones  que se imprimen en la OC"
                value={datosFormulario.observaciones}
                name='observaciones'
                onChange={almacenar}
              // InputProps={{ readOnly: true }}

              />
            </Grid>
            {
              obs && obs.length ?
                <Grid item xs={0.5}>
                  <Tooltip arrow placement="bottom" title={"Hay comentarios"}>
                    <IconButton onClick={() => setverobs(true)}>
                      <WysiwygIcon color="warning" />
                    </IconButton>
                  </Tooltip>

                </Grid>
                : null
            }
          </Grid>

          <Grid mt={1} container direction="row" justifyContent="space-between">
            <Button
              variant="contained"
              style={{ backgroundColor: '#ff3333', color: '#ffffff', marginRight: '5%' }}
              onClick={handleClose}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              onClick={generarOrdenCompra}
              disabled={isProcessing || estadoRequerimiento === 58
              }
              style={{ backgroundColor: '#2e7d32', color: '#ffffff' }}
            >
              {isProcessing ? 'Procesando...' : 'Guardar Orden'}
            </Button>
          </Grid>
        </Box>
      </Container>

      {openDialog && (
        <FormAgregarPedido
          getTotal={calcularTotales}
          open={setopenDialog}
          reqmaterial={reqMaterial}
          uuid={uuidordencompra}
          actualizar={obtenerListaMaterial}
          tabla={settabla}
        />
      )}
      {openclose && (
        <UploadFiles
          fileId={props.datos.uuid_requerimiento}
          fileIdcompra={uuidordencompra}
          open={openclose}
          setOpen={setOpenClose}
          title={"Presupuestos cargados"}
        />
      )}
      {createModalOpen && (
        <AgregarMateriales
          position={1}
          getTotal={calcularTotales}
          open={setCreateModalOpen}
          actualizar={obtenerListaMaterial}
          uuidordencompra={uuidordencompra}
        />
      )}
      {notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleCloseNotificacion}
          severity={notificacion.severity}
        />
      )}
      {modalVacio && <Modalcondicionnull open={setmodalVacio} proveedor={proveedorSelected} />}
      {modalListaPendiente &&
        reqMaterial?.uuid_requerimiento &&
        pendientesRequerimientoOriginal.length > 0 && (
          <Dialog open={modalListaPendiente} onClose={handleCloseModal} fullWidth maxWidth="sm">
            <DialogTitle sx={{ fontWeight: "bold", color: "#2E86C1" }}>
              Artículos Pendientes
            </DialogTitle>

            <DialogContent dividers>
              <Typography gutterBottom>
                Hay <b>{pendientesRequerimientoOriginal.length}</b> artículo(s) pendiente(s) de compra en este requerimiento.
                La orden de compra se generará, pero el requerimiento aún tiene ítems sin asignar.
              </Typography>

              {obs.some(o => o.estado === 313) && (
                <Box sx={{ mt: 2 }}>
                  <Typography color="error">
                    ⚠️ Además, los siguientes requerimientos asociados a esta orden de compra también tienen ítems pendientes de compra:
                  </Typography>
                  <ul>
                    {obs
                      .filter(o => o.estado === 313)
                      .map(o => (
                        <li key={o.idrequerimiento}>
                          <Typography component="span" color="error" fontWeight="bold">
                            {o.idrequerimiento}
                          </Typography>
                        </li>
                      ))}
                  </ul>
                </Box>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCloseModal} variant="contained" color="primary">
                Continuar
              </Button>
            </DialogActions>
          </Dialog>
        )}

      {modalOtrosPendientes && (
        <Dialog open={modalOtrosPendientes} onClose={() => setModalOtrosPendientes(false)}>
          <DialogTitle>Advertencia</DialogTitle>
          <DialogContent>
            <Typography>
              Existen ítems pendientes, pero pertenecen a los siguientes requerimientos:
            </Typography>
            <ul>
              {obs
                .filter(o => o.estado === 313)
                .map(o => (
                  <li key={o.idrequerimiento}>
                    <Typography component="span" fontWeight="bold">
                      {o.idrequerimiento}
                    </Typography>
                  </li>
                ))}
            </ul>
            {/* <Typography>
              El estado del requerimiento actual no se modificará.
            </Typography> */}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setModalOtrosPendientes(false);
                if (callbackPendiente) callbackPendiente();
              }}
              color="primary"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {verobs &&
        <Modalhaycomentarios
          open={verobs}
          setopen={setverobs}
          datos={obs}
        />
      }

      <br />
    </div>
  );
};

export default AddOrdenCompra;
